export const catBreeds = [
  'Другое',
  'Абиссинская кошка',
  'Австралийская дымчатая кошка',
  'Азиатская табби',
  'Американская жесткошёрстная кошка',
  'Американская короткошёрстная кошка',
  'Американский кёрл',
  'Анатолийская кошка',
  'Ангорская кошка',
  'Аравийский мау',
  'Ашера (кошка)',
  'Балинезийская кошка',
  'Бамбино (порода)',
  'Бенгальская кошка (домашняя)',
  'Бирманская кошка',
  'Бомбейская кошка',
  'Бразильская короткошёрстная кошка',
  'Британская длинношёрстная кошка',
  'Британская короткошёрстная кошка',
  'Бурма',
  'Бурмилла',
  'Ванская кошка',
  'Гавана',
  'Гималайская кошка',
  'Двельф',
  'Девон-рекс',
  'Домашняя длинношёрстная кошка',
  'Домашняя короткошёрстная кошка',
  'Донской сфинкс',
  'Европейская кошка',
  'Египетский мау',
  'Йоркская шоколадная кошка',
  'Канаани',
  'Карельский бобтейл',
  'Картезианская кошка',
  'Кимрийская кошка',
  'Кинкалоу',
  'Корат (кошка)',
  'Корниш-рекс',
  'Курильский бобтейл',
  'Кхао-мани',
  'Лаперм',
  'Ликой',
  'Манчкин',
  'Международная федерация кошек',
  'Мейн-кун',
  'Меконгский бобтейл',
  'Минскин',
  'Мэнкс',
  'Невская маскарадная кошка',
  'Немецкий рекс',
  'Нибелунг',
  'Норвежская лесная кошка',
  'Ориентальная кошка',
  'Оцикет',
  'Персидская кошка',
  'Пиксибоб',
  'Питерболд',
  'Рагамаффин',
  'Русская голубая кошка',
  'Рэгдолл',
  'Саванна',
  'Сейшельская кошка',
  'Селкирк-рекс',
  'Серенгети',
  'Сиамская кошка',
  'Сибирская кошка',
  'Сингапурская кошка',
  'Скиф-той-боб',
  'Сноу-шу',
  'Сококе',
  'Сомали (кошка)',
  'Сфинкс канадский',
  'Тайская кошка',
  'Тойгер',
  'Тонкинская кошка',
  'Турецкий ван',
  'Украинский левкой',
  'Уральский рекс',
  'Хауси',
  'Цейлонская кошка',
  'Шотландская кошка (скоттиш-фолд)',
  'Шотландская кошка (скоттиш-страйт)',
  'Шотландская кошка (хайленд-фолд)',
  'Шотландская кошка (хайленд-страйт)',
  'Эгейская кошка',
  'Экзотическая кошка',
  'Эльф',
  'Японский бобтейл'
];
